import { render, staticRenderFns } from "./ServiciosTransbordosPage.vue?vue&type=template&id=42112498"
import script from "./ServiciosTransbordosPage.vue?vue&type=script&lang=js"
export * from "./ServiciosTransbordosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports